export const sharedFeatureKey = 'shared';

export interface SharedState {
    tableRefresher: Record<string, string[]>,
}

export function createInitialSharedState(): SharedState {
    return {
        tableRefresher: {},
    };
}
